module.exports = __webpack_public_path__ + "static/media/sidebar-email.0e28fb53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-email.svg
// module id = 791
// module chunks = 0